import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { UtilserviceService } from '../utilservice.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(private util: UtilserviceService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // ❌ Skip Google Maps API
    if (req.url.includes('maps.googleapis.com')) {
      return next.handle(req);
    }

    // ❌ Skip refresh token API
    if (req.url.includes('refreshtoken')) {
      return next.handle(req);
    }

    // ✅ START LOADER
    this.util.startLoad();

    return next.handle(req).pipe(
      catchError((error) => {
        this.util.dismissLoader(); // 🔥 force dismiss on error
        return throwError(() => error);
      }),
      finalize(() => {
        this.util.dismissLoader();
      })
    );
  }
}